module.exports = __webpack_public_path__ + "static/img/avatar-default.4cf91a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew/register/avatar-default.png
// module id = YDP2
// module chunks = 1